import { Button } from 'themes/playful/components/Button/Button';
import { Title } from 'themes/playful/components/Title/Title';

import s from './GiftCardsSection.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const GiftCardsSection = () => (
  <section className={s1.content}>
    <div className={s.wrapper}>
      <Title className={s.title}>Giftcards</Title>
      <Button to="/gift-cards">buy here</Button>
    </div>
  </section>
);
